<template>
  <div>
    Closing Price above the {{ rule.config.ma_days }} day moving average and stock has increased
    {{ rule.config.consecutive_days }} Consecutive Days
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {}
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
